import { custom, schema } from "@anna-money/anna-web-lib/serializer";

export enum FeatureState {
  Enabled = "ENABLED",
  Disabled = "DISABLED",
}

const featureStateProperty = (): ReturnType<typeof custom<FeatureState>> =>
  custom(
    "FeatureState",
    (value: unknown): FeatureState => {
      if (typeof value !== "string" || !Object.values(FeatureState).includes(value as FeatureState)) {
        throw new Error(`Invalid FeatureState: ${String(value)}`);
      }
      return value as FeatureState;
    },
    (state: FeatureState) => state as string,
  );

export class FeatureSet extends schema(
  {
    // formation_sumsub_sdk_v2
    formationSumsubSdkV2: featureStateProperty().optional(),
    formationPaymentStatus: featureStateProperty().optional(),
    // Express checkout
    formationExpressCheckout: featureStateProperty().optional(),
    // One page checkout (combined basket + payment)
    formationOnePageCheckout: featureStateProperty().optional(),
    // POA verification at address level with polling
    formationPoaVerification: featureStateProperty().optional(),
    // formation_upgraded_shares
    formationUpgradedShares: featureStateProperty().optional(),
    // ACSP IDV submission enabled - when disabled, customers verify identity themselves at Companies House
    formationAcspIdvSubmissionEnabled: featureStateProperty().optional(),
    // AU ASIC agent nomination step in the ACN company flow
    formationAsicNomination: featureStateProperty().optional(),
    // UK home-address: "have you lived here 12 months" question + previous address capture
    formationUkYearAddressCheck: featureStateProperty().optional(),
    // SCA early access signup checkbox on the AU ACN confirm step
    formationScaSignup: featureStateProperty().optional(),
    // UK new pricing plans experiment (formations_new_pricing_jul)
    formationsNewPricingJul: featureStateProperty().optional(),
    // Just Register card copy: business account on the Business Plan (formations_just_register_includes_business_account)
    formationsJustRegisterIncludesBusinessAccount: featureStateProperty().optional(),
    // Compliance check call - final phone-call compliance gate before GB application submission
    formationComplianceCall: featureStateProperty().optional(),
    // Partner offers step in the GB incorporation flow (Sprintlaw, IONOS, Admiral)
    formationPartnerOffers: featureStateProperty().optional(),
  },
  "FeatureSet",
) {}

export type Feature = keyof FeatureSet;
